var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCommissionIcon2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 87,
    height: 122,
    viewBox: "0 0 87 122",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.4675 87.2896H5.23584V122H19.4675V87.2896Z",
    fill: "#7742CA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.4084 62.6431H26.1768V122H40.4084V62.6431Z",
    fill: "#7742CA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.5862 44.5691H49.3545V122H63.5862V44.5691Z",
    fill: "#7742CA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.3562 23.2087H72.1245V122H86.3562V23.2087Z",
    fill: "#7742CA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.1294 8.0101L70.0916 11.7071L68.8717 0L60.1294 8.0101Z",
    fill: "#FFAC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.37306 70.448C0.966444 70.448 0.559824 70.2426 0.356515 69.8318C0.153205 69.2156 0.356515 68.5995 0.966444 68.3941C1.37306 68.1887 44.0681 51.7577 65.009 7.18869C65.2123 6.57253 65.8222 6.36714 66.4322 6.77792C67.0421 6.98331 67.2454 7.59947 66.8388 8.21563C45.6946 53.4008 2.1863 70.2426 1.77968 70.448C1.57637 70.448 1.57637 70.448 1.37306 70.448Z",
    fill: "#FFAC00"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 86,
    height: 122,
    fill: "white",
    transform: "translate(0.356445)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommissionIcon2);
export default __webpack_public_path__ + "static/media/commission-icon-2.9f19329dbbd8ead8daabd45301023698.svg";
export { ForwardRef as ReactComponent };